import React, { forwardRef } from "react";
import { SidePanelBase, SidePanelBaseProps, SidePanelContent, SidePanelFooter, SidePanelHeader } from "./SidePanel";

interface CustomSidePanelProps extends SidePanelBaseProps {
  title: string
  contentClassName?: string
}

export const CustomSidePanel = forwardRef((props: React.PropsWithChildren<CustomSidePanelProps>, ref) => {
  return <SidePanelBase
    ref={ref}
    trigger={props.trigger}
    id={props.id}
    size={props.size}
  >
    <SidePanelHeader title={props.title} />
    <SidePanelContent className={props.contentClassName}>
      {props.children}
    </SidePanelContent>
    <SidePanelFooter />
  </SidePanelBase>
});